import hide from './hide';
import show from './show';
import register from './register';

export default {
  hide,
  show,
  register,
};
